import React, { useContext } from 'react';
import { GlobalStyles } from '../components/layout/GlobalStyles';
import { Nav } from '../components/nav/Nav';
import { siteContext } from './SiteContextProvider';
import { Map } from '../components/Map';
import { ContactForm } from '../components/Contact-Form';
import { Footer } from '../components/Footer';
import { Hours } from '../components/Hours';
import { InsurancePanel } from '../components/Insurance-Panel';
import { MDXProvider } from '@mdx-js/react';
import { BluePanel } from '../components/Blue-Panel';

const shortcodes = { BluePanel, Hours };

export const DefaultLayout: React.FC = ({ children }) => {
    const { setDesktopActive } = useContext(siteContext);
    return (
        <div id="layout">
            <Nav home />
            <GlobalStyles />
            <div onMouseEnter={() => setDesktopActive(false)}>
                <MDXProvider components={shortcodes}>{children}</MDXProvider>
                <InsurancePanel />
                <Hours />
                <Map />
                <ContactForm />
                <Footer />
            </div>
        </div>
    );
};
